import { ADMIN_ACTIONS, CURRENT_ACTIONS } from '../../../actions/types'
import brandit_rails from '../../../api/brandit_rails'
import { clearAuthAction } from '../../storeConfig/slices/slice.auth'

// const config = {}

export const clearAgency = () => async dispatch => {
  dispatch({ type: CURRENT_ACTIONS.CLEAR_AGENCY })
}

/**
 */

/**
 * @typedef {function(import('redux').Dispatch): Promise<void>} HandleLogoutThunk
 *
 * @function handleLogout
 * @param {import('../../../reducers/adminsReducer').CurrentAdmin} currentAdmin
 * @returns {function(import('redux').Dispatch): Promise<void>}
 */
export const handleLogout =
  (currentAdmin = {}) =>
  async dispatch => {
    const associatedPortalInfo = currentAdmin.associated_portal_info
    const currentStoreDomain = localStorage.getItem('store_domain')
    const shouldRedirectToStore = currentStoreDomain && currentStoreDomain.length > 0

    const storeUrl =
      currentStoreDomain ??
      (associatedPortalInfo && associatedPortalInfo[0] ? associatedPortalInfo[0].store_domain : '/')

    dispatch({ type: 'SET_LOGIN_STATUS', payload: '' })
    dispatch({ type: ADMIN_ACTIONS.SET_CURRENT, payload: {} })
    dispatch({ type: CURRENT_ACTIONS.CLEAR_AGENCY })
    dispatch(clearAuthAction())

    if (currentAdmin?.logged_in_as)
      await brandit_rails.delete(currentAdmin.logged_in_as === 'Agency' ? '/sessions' : 'admin/organization/sessions')

    // ** Remove user, accessToken & refreshToken from localStorage (VUEXY FUNCTION)
    // sessionStorage.removeItem('userData')
    // sessionStorage.removeItem(config.storageTokenKeyName)
    // sessionStorage.removeItem(config.storageRefreshTokenKeyName)

    // // ** Remove user, accessToken & refreshToken from localStorage (MF FUNCTION)
    // sessionStorage.removeItem('email')
    // sessionStorage.removeItem('admin_id')
    // sessionStorage.removeItem(config.storageTokenKeyName)

    sessionStorage.clear()

    // Remove store domain from local and session storage
    sessionStorage.removeItem('store_domain')
    localStorage.removeItem('store_domain')

    sessionStorage.removeItem('agencyAuthToken')

    if (typeof window.Featurebase === 'function') {
      window.Featurebase('shutdown')
    }

    const channel = new BroadcastChannel('storageSync')
    channel.postMessage({ type: 'logout' }) // Broadcast logout to other tabs
    channel.close()

    if (shouldRedirectToStore) window.location.href = `${storeUrl}?logout=true`
  }
